import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Já tentei tráfego antes e não funcionou. Por que agora seria diferente?",
    a: "Porque tráfego sozinho não sustenta resultado. Quando uma campanha não funciona, o problema quase nunca está apenas na plataforma. Pode estar no criativo, na página, na oferta ou no posicionamento. Por isso, antes de qualquer proposta, analisamos a estrutura para entender onde está o gargalo real. Preencha o formulário e solicite seu diagnóstico.",
  },
  {
    q: "E se minha empresa ainda não estiver pronta para contratar?",
    a: "O formulário serve justamente para entender isso. Nem toda empresa precisa anunciar mais. Algumas precisam ajustar a comunicação, melhorar a página ou organizar a estrutura antes de investir. Ao preencher o formulário, conseguimos avaliar seu momento e indicar o caminho mais estratégico.",
  },
  {
    q: "Quanto custa o serviço?",
    a: "Depende do que sua empresa precisa. Não trabalhamos com proposta genérica porque cada operação tem um cenário diferente. Primeiro, analisamos suas respostas no formulário. Depois disso, apresentamos uma direção clara, com base no que faz sentido para o seu momento.",
  },
  {
    q: "Por que preciso preencher um formulário antes?",
    a: "Porque uma proposta sem diagnóstico é apenas um chute. O formulário nos ajuda a entender sua empresa, seu objetivo, seus desafios e o que pode estar travando seus resultados. Assim, a análise fica mais precisa e a recomendação mais estratégica.",
  },
  {
    q: "E se eu quiser pensar mais antes de preencher?",
    a: "Tudo bem. Mas enquanto a decisão é adiada, os gargalos continuam afetando seus resultados. O formulário não te prende a nada. Ele apenas abre o primeiro passo para entender se existe uma oportunidade real de crescimento para sua empresa.",
  },
  {
    q: "O que acontece depois que eu preencher o formulário?",
    a: "Nossa equipe analisa as informações enviadas e identifica se conseguimos ajudar de forma estratégica. Caso faça sentido, entramos em contato com um direcionamento mais claro sobre os próximos passos.",
  },
  {
    q: "Minha empresa precisa estar faturando muito para solicitar o diagnóstico?",
    a: "Não necessariamente. O mais importante é ter clareza de que existe um objetivo de crescimento e disposição para estruturar melhor a aquisição de clientes. O formulário ajuda a entender se sua empresa está no momento certo para avançar.",
  },
  {
    q: "Esse diagnóstico é gratuito?",
    a: "Sim. O diagnóstico inicial é gratuito e serve para avaliar o cenário da sua empresa antes de qualquer proposta. Você entende com mais clareza onde pode estar perdendo oportunidades e quais caminhos fazem sentido seguir.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="faq-section" id="faq">
      <div className="faq-fade-top" aria-hidden="true" />
      <div className="faq-fade-bottom" aria-hidden="true" />
      <div className="faq-wrap">
        <aside className="faq-aside">
          <span className="faq-tag">FAQ</span>
          <h2 className="faq-title">Perguntas Frequentes</h2>

        </aside>

        <div className="faq-content">
          <div className="faq-list">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className={`faq-item${isOpen ? " is-open" : ""}`}>
                  <button
                    className="faq-q"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.q}</span>
                    <span className="faq-icon">
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <div className="faq-a-wrap">
                    <p className="faq-a">{item.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>

  );
}
